import { Info } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { ICS204_ASSIGNEE_COLUMN_TOOLTIP } from './assignmentStatus';

type AssigneeInfoLabelProps = {
  /** When true, omit the "Assignee" text (icon-only). */
  iconOnly?: boolean;
  className?: string;
};

/** "Assignee" label with hover-only info tooltip to the right of the text. */
const AssigneeInfoLabel = ({
  iconOnly = false,
  className,
}: AssigneeInfoLabelProps) => (
  <span
    className={`tw:inline-flex tw:items-center tw:gap-1 ${className ?? ''}`}
  >
    {iconOnly ? null : <span>Assignee</span>}
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger
          render={
            <span
              role="button"
              tabIndex={0}
              aria-label="About Assignee"
              className="tw:inline-flex tw:shrink-0 tw:text-[var(--text-weak)]"
              data-testid="ics204-assignee-info"
              onClick={(e) => e.stopPropagation()}
              onPointerDown={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
            >
              <Info className="tw:h-3.5 tw:w-3.5" />
            </span>
          }
        />
        <TooltipContent side="bottom" className="tw:max-w-xs">
          {ICS204_ASSIGNEE_COLUMN_TOOLTIP}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </span>
);

export default AssigneeInfoLabel;
